import { z } from "zod";
import { PetPrefectureSchema } from "#core/pets/PetStoreLocation.js";
export const PetShopSchema = z.enum([
    "pet-forest",
    "century-pet",
    "happy-bell",
    "pet-eco",
    "maruone",
    "pet-plus",
    "kojima",
    "petit-maria",
]);
export const PetSexSchema = z.enum(["male", "female", "unknown"]);
export const PetParentSchema = z.object({
    display: z.string(),
    weightKg: z.number().positive().optional(),
});
export const PetParentsSchema = z.object({
    father: PetParentSchema.optional(),
    mother: PetParentSchema.optional(),
});
export const PetMediaSchema = z.discriminatedUnion("type", [
    z.object({ type: z.literal("image"), url: z.string() }),
    z.object({ type: z.literal("youtube"), videoId: z.string() }),
]);
export const PetEntrySchema = z.object({
    shop: PetShopSchema,
    breed: z.string(),
    breedNormalized: z.string(),
    sex: PetSexSchema,
    birthDate: z.string(),
    price: z.number(),
    storeName: z.string(),
    prefecture: PetPrefectureSchema.optional(),
    storeAddress: z.string().optional(),
    storeUrl: z.string().optional(),
    imageUrl: z.string().optional(),
    media: z.array(PetMediaSchema).optional(),
    detailUrl: z.string(),
    isNew: z.boolean(),
    parents: PetParentsSchema.optional(),
});
export const PetEntriesSchema = z.array(PetEntrySchema);
